import { Role } from './types';

export const userRoleLabelMapping: Record<Role, string> = {
  [Role.ADMIN]: 'admin',
  [Role.DISTRICT_ADMIN]: 'district admin',
  [Role.SCHOOL_ADMIN]: 'school admin',
  [Role.TEACHER]: 'teacher'
};
